console.log('components');

import './components/swiper';
